// PARA-133 (AD-6) — ЕДИНСТВЕННЫЙ источник правды о СОСТАВЕ справки: какие
// статьи существуют, в каком порядке и к какой категории относятся.
// Текстов здесь нет вовсе — они живут в namespace 'faq' (4 локали), а
// изображения — в карте faqScreenshots.ts. Добавление статьи = строка в
// FAQ_ARTICLES + ключи в четырёх словарях; компоненты не меняются.

export type FaqCategoryId =
  'gettingStarted' | 'tasks' | 'procrastination' | 'reports' | 'billing' | 'voice' | 'support';

/** AD-14 — набор кадров фиксирован типом: «мёртвый» screenshotId не соберётся,
 * а лишний PNG в src/assets/faq/ поймает faqAssets.test.ts. */
export type ScreenshotId =
  | 'backlog'
  | 'language-switcher'
  | 'task-form'
  | 'task-detail'
  | 'procrastination-energy'
  | 'procrastination-suggested'
  | 'reports'
  | 'billing-plans'
  | 'voice-recording'
  | 'voice-consent'
  | 'voice-gated';

export interface FaqArticle {
  id: string;
  categoryId: FaqCategoryId;
  /** null — ответ самодостаточен текстом; лишний кадр стоит 4 файла бандла. */
  screenshotId: ScreenshotId | null;
}

/** Р-5 — единственное место, где записан адрес поддержки. В словари он НЕ
 * попадает: там стоит плейсхолдер {{email}}, подставляемый интерполяцией.
 * Так идентичность адреса во всех локалях гарантирована структурно, а не
 * побайтовым сравнением в тесте (AC-19, EC-20). */
export const SUPPORT_EMAIL = 'datskevichsergey@gmail.com';

/** Порядок категорий на экране (AC-2). */
export const FAQ_CATEGORIES: readonly FaqCategoryId[] = [
  'gettingStarted',
  'tasks',
  'procrastination',
  'reports',
  'billing',
  'voice',
  'support',
];

/** 21 статья в порядке отображения внутри своих категорий (AC-2). */
export const FAQ_ARTICLES: readonly FaqArticle[] = [
  { id: 'what-is-app', categoryId: 'gettingStarted', screenshotId: 'backlog' },
  { id: 'how-login', categoryId: 'gettingStarted', screenshotId: null },
  { id: 'change-language', categoryId: 'gettingStarted', screenshotId: 'language-switcher' },
  { id: 'create-task', categoryId: 'tasks', screenshotId: 'task-form' },
  { id: 'task-sizes', categoryId: 'tasks', screenshotId: 'backlog' },
  { id: 'task-priority', categoryId: 'tasks', screenshotId: 'task-detail' },
  { id: 'subtasks', categoryId: 'tasks', screenshotId: 'task-detail' },
  { id: 'edit-task', categoryId: 'tasks', screenshotId: null },
  { id: 'complete-task', categoryId: 'tasks', screenshotId: 'procrastination-suggested' },
  { id: 'why-lazy-button', categoryId: 'procrastination', screenshotId: 'procrastination-energy' },
  {
    id: 'suggestion-actions',
    categoryId: 'procrastination',
    screenshotId: 'procrastination-suggested',
  },
  { id: 'nothing-suggested', categoryId: 'procrastination', screenshotId: null },
  { id: 'reports-content', categoryId: 'reports', screenshotId: 'reports' },
  { id: 'plans-diff', categoryId: 'billing', screenshotId: 'billing-plans' },
  { id: 'pay-stars', categoryId: 'billing', screenshotId: null },
  { id: 'cancel-subscription', categoryId: 'billing', screenshotId: null },
  { id: 'task-limit', categoryId: 'billing', screenshotId: null },
  { id: 'voice-how', categoryId: 'voice', screenshotId: 'voice-recording' },
  // Совпадение id статьи и id кадра допустимо — это разные типы и разные
  // пространства имён (статья объясняет согласие, кадр показывает модалку).
  { id: 'voice-consent', categoryId: 'voice', screenshotId: 'voice-consent' },
  { id: 'voice-unavailable', categoryId: 'voice', screenshotId: 'voice-gated' },
  { id: 'contact-support', categoryId: 'support', screenshotId: null },
];

/** Статьи одной категории в порядке каталога. */
export function articlesOfCategory(categoryId: FaqCategoryId): FaqArticle[] {
  return FAQ_ARTICLES.filter((article) => article.categoryId === categoryId);
}
